import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import React, { useState } from 'react';
import { AccountSortDialogContent } from '@/components/account-form/account-sort-dialog-content';

interface Props {
  children: React.ReactNode;
}

export function AccountSortDialog({ children }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <AccountSortDialogContent onClose={() => setOpen(false)} />
    </Dialog>
  );
}
